'use client';

import { X } from 'lucide-react';
import Link from 'next/link';
import Image from 'next/image';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import config from '@/config';

interface AgeConfirmationDialogProps {
  isOpen: boolean;
  isConfirming?: boolean;
  onConfirm: () => void;
  onDecline: () => void;
}

export function AgeConfirmationDialog({
  isOpen,
  isConfirming = false,
  onConfirm,
  onDecline,
}: AgeConfirmationDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onDecline}>
      <DialogContent
        hideCloseButton
        className="max-w-[90%] sm:max-w-[490px] !rounded-xl p-5 bg-[#F2F3F7] flex flex-col gap-0"
      >
        <div className="relative">
          <button
            type="button"
            onClick={onDecline}
            className="absolute right-0 top-0 bg-[#E6E6E6] rounded-[7.5px] p-[9px] hover:opacity-80 transition-opacity"
          >
            <X className="h-3 w-3" />
          </button>

          <Image
            src="/images/age-confirm@2x.webp"
            alt="18+ banner"
            className="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] mx-auto object-cover"
            width={100}
            height={100}
          />

          <div className=" flex items-center justify-center">
            <h2 className="mt-2 text-[22px] sm:text-2xl font-extrabold text-[#1B1D22] uppercase text-center">
              Контент только для 18+
            </h2>
          </div>
        </div>

        <div className="text-center ">
          <p className="mt-2 text-sm font-normal text-[#1B1D22]">Вам уже есть 18 лет?</p>
        </div>

        <div className="mt-6 flex gap-[5px] sm:gap-2 flex-col sm:flex-row">
          <Button
            onClick={onDecline}
            variant="outline"
            disabled={isConfirming}
            className="flex-1 h-[35px] sm:h-[46px]  hover:bg-[#E8E9ED] text-[#1B1D22] text-xs sm:text-sm font-normal rounded-xl !border-1 border-[#A7ADC5]"
          >
            Нет
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isConfirming}
            className="flex-1 h-[35px] sm:h-[46px] bg-[#505CFF] hover:bg-[#505CFF]/90 text-white text-xs sm:text-sm font-normal rounded-xl"
          >
            {isConfirming ? 'Подтверждение...' : 'Да'}
          </Button>
        </div>

        <div className="mt-6 text-xs sm:text-sm text-[#898989] font-normal text-center">
          Нажимая кнопку, вы соглашаетесь на обработку указанных данных в соответствии с{' '}
          <Link
            href={`${config.API_URL}/api/v1/documents/terms`}
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-[#505CFF] hover:opacity-80"
          >
            Условиями использования
          </Link>
        </div>
      </DialogContent>
    </Dialog>
  );
}
